var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "formDynamic",
          staticClass: "attrFrom mb20",
          attrs: {
            size: "small",
            model: _vm.formDynamic,
            rules: _vm.rules,
            "label-width": "75px",
          },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "规格名称：", prop: "ruleName" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: {
                          maxlength: "20",
                          placeholder: "请输入标题名称",
                        },
                        model: {
                          value: _vm.formDynamic.ruleName,
                          callback: function ($$v) {
                            _vm.$set(_vm.formDynamic, "ruleName", $$v)
                          },
                          expression: "formDynamic.ruleName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._l(_vm.formDynamic.ruleValue, function (item, index) {
                return _c(
                  "el-col",
                  { key: index, staticClass: "noForm", attrs: { span: 24 } },
                  [
                    _c("el-form-item", [
                      _c("div", { staticClass: "acea-row row-middle" }, [
                        _c("span", { staticClass: "mr5" }, [
                          _vm._v(_vm._s(item.value)),
                        ]),
                        _c("i", {
                          staticClass: "el-icon-circle-close",
                          on: {
                            click: function ($event) {
                              return _vm.handleRemove(index)
                            },
                          },
                        }),
                      ]),
                      _c(
                        "div",
                        { staticClass: "rulesBox" },
                        _vm._l(item.detail, function (j, indexn) {
                          return _c(
                            "el-tag",
                            {
                              key: indexn,
                              staticClass: "mb5 mr10",
                              attrs: {
                                size: "medium",
                                "disable-transitions": false,
                              },
                            },
                            [_vm._v(" " + _vm._s(j) + " ")]
                          )
                        }),
                        1
                      ),
                    ]),
                  ],
                  1
                )
              }),
              _vm.formDynamic.ruleValue.length === 0
                ? _c(
                    "el-col",
                    {
                      staticStyle: {
                        "padding-left": "0",
                        "padding-right": "0",
                      },
                      attrs: { span: 24 },
                    },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 9 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "规格：" } },
                            [
                              _c("el-input", {
                                staticClass: "selWidth",
                                attrs: { placeholder: "请输入规格" },
                                model: {
                                  value: _vm.attrsName,
                                  callback: function ($$v) {
                                    _vm.attrsName = $$v
                                  },
                                  expression: "attrsName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 9 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "规格值：" } },
                            [
                              _c("el-input", {
                                staticClass: "selWidth",
                                attrs: { placeholder: "请输入规格值" },
                                model: {
                                  value: _vm.attrsVal,
                                  callback: function ($$v) {
                                    _vm.attrsVal = $$v
                                  },
                                  expression: "attrsVal",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c("el-button", { on: { click: _vm.offAttrName } }, [
                            _vm._v("取消"),
                          ]),
                          _c(
                            "el-button",
                            {
                              staticClass: "mr10",
                              attrs: { type: "primary" },
                              on: { click: _vm.createAttrName },
                            },
                            [_vm._v("确定")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.spinShow
                ? _c("Spin", { attrs: { size: "large", fix: "" } })
                : _vm._e(),
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogFormVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.dialogFormVisible = false
                    },
                  },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        { staticClass: "footer acea-row" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  return _vm.resetForm("formDynamic")
                },
              },
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.loadingBtn },
              on: {
                click: function ($event) {
                  return _vm.handleSubmit("formDynamic")
                },
              },
            },
            [_vm._v("确定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }